"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SignalBlockInfoSchema = void 0;
const zod_1 = require("zod");
exports.SignalBlockInfoSchema = zod_1.z.object({
    name: zod_1.z.string().optional(),
    blockPattern: zod_1.z.string().optional(),
    index: zod_1.z.number(),
});
//# sourceMappingURL=SignalBlockInfo.js.map